import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { MsdNotes } from "../models";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create ON Hand and return same object
 */

export const GetMSDNotes = async (osdNumber: number): Promise<MsdNotes> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.MSD_NOTES)}/${osdNumber}`);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createMSDNotes, { badRequestOrder: "errorsFirst" });
  }
};
